export default "__VITE_ASSET__0a75e62d__"